export const productAlerts = "/product_alerts";
